import { useEffect } from 'react';
import { useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import ShowSelectedProjects from '../../project/show-selected-projects/ShowSelectedProjects';
import NotFound from '../../project/not-found/NotFound';
import GenericHelmet from '../../project/generic-helmet/GenericHelmet';
import { trackPageView } from '../../support-and-tracking/analytics-actions';
import Main from '../../frame/main/Main';
import { fetchEvent } from '../event-actions';
import { fetchProjectsForEvent } from '../../project/project-actions';

const MAX_NUMBER_OF_PROJECTS_FOR_EVENT = 50;

const ShowEvent = () => {
    const dispatch = useDispatch();
    const params = useParams();

    const eventId = parseInt(params.eventId, 10);

    const event = useSelector((state) => state.events.events.find((e) => e.id === eventId));
    const projectIds = useSelector((state) => state.events.projectIds);
    const totalAmountCollected = useSelector((state) => state.events.totalAmountCollected);

    useEffect(() => {
        trackPageView({ urlAsEvent: 'events', properties: { 'event-id': params.eventId } });
    }, [dispatch, params]);

    if (!event?.id) {
        return (
            <Main>
                <NotFound />
            </Main>
        );
    }

    return (
        <Main>
            <GenericHelmet title={event.name} description={event.descriptionStripped} imageUrl={event.img_url}>
                <ShowSelectedProjects
                    projectIds={projectIds}
                    showSum={event.profile?.showSum}
                    hideProjectImages={event.profile?.hideProjectImages}
                    totalAmountCollected={totalAmountCollected}
                    maxProjects={MAX_NUMBER_OF_PROJECTS_FOR_EVENT}
                    actionInformation={`Event - ${event.name}`}
                />
            </GenericHelmet>
        </Main>
    );
};

export const loader = async ({ dispatch, params }) => {
    const eventId = parseInt(params.eventId, 10);
    if (isNaN(eventId)) {
        return null;
    }
    await Promise.all([dispatch(fetchEvent(eventId)), dispatch(fetchProjectsForEvent(eventId))]);
    return null;
};

export default ShowEvent;
